import { change } from './func';

change();
